<template>
  <div class="container">

    <div class="images-wrapper">
      <span
        class="image-item-wrapper"
        v-for="image in currentImages"
        :key="image.dish_img_uuid"
      >
        <img :src="image" v-lazy="image" alt="">
      </span>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handlePagination"
        :page-count="maxSize"
        :current-page.sync="currentPage"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
// import {errorMessage, successMessage} from '@/lib/msg';

export default {
  name: 'imageWrapperNoChecking',
  components: {
  },
  props: {
    images: {
      tyep: Array,
      default () {
        return [];
      }
    },
    current_class_id: ''
  },
  data () {
    return {
      pageSize: 300,
      currentPage: 1
    };
  },
  mounted () {
    this.$emit('pageChange', this.currentPage, this.currentPage === this.maxSize);
  },
  methods: {
    handlePagination (index) {
      this.currentPage = index;
      this.$emit('pageChange', index, index === this.maxSize);
    }
  },
  computed: {
    maxSize () {
      return Math.ceil(this.images.length / this.pageSize);
    },
    currentImages () {
      return this.images.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    }
  },
  watch: {
    current_class_id () {
      this.$nextTick(() => {
        this.currentPage = 1;
      });
    }
  }};
</script>
<style lang="scss" scoped>
  .container {
    position: relative;
    margin: 10px;
    .images-wrapper {
      display: inline-block;
      width: 100%;
      min-height: 40vh;
      .image-item-wrapper {
        display: inline-block;
      }
    }
    .pagination {
      margin: 10px 0;
      width: 100%;
      text-align: center;
    }
  }
</style>
